import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { changeNotificationPreference, getNotificationPreference } from '@/api/notification';
import { accountKeys } from '@/lib/queryKeys';

/** 알림 수신 설정 조회(specs/080) — 창이 열려 있을 때만 읽는다. */
export function useNotificationPreferenceQuery(enabled: boolean) {
  return useQuery({
    queryKey: accountKeys.notificationPreference,
    queryFn: getNotificationPreference,
    enabled,
  });
}

/** 알림 수신 켜기·끄기 — 성공 값으로 캐시를 바로 맞춘다. */
export function useChangeNotificationPreference() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: changeNotificationPreference,
    onSuccess: (data) => queryClient.setQueryData(accountKeys.notificationPreference, data),
  });
}
